export const PRIMARY_API_HOST =
  process.env.VUE_APP_PRIMARY_API_URL || "https://reader-pull.shamudeen.ca";

export const FALLBACK_API_HOST =
  process.env.VUE_APP_FALLBACK_API_URL ||
  "https://reader-pull-602725531886.us-central1.run.app";

export const API_HOST = PRIMARY_API_HOST;

export const STATIC_HOST = process.env.VUE_APP_STATIC_HOST
  ? process.env.VUE_APP_STATIC_HOST
  : "https://chapters-0d5o.onrender.com/pages/";
